import {
  TRANSACTION_STATE,
  TRANSACTION_STATUS,
  TRANSACTION_TYPES,
  isValidStatusForType,
  isValidTransactionType,
} from './constants';
import { getFinancialDate } from './dates';
import { getAmountCents } from './money';

export const getTransactionState = (record) => {
  if (!record || !isValidTransactionType(record.tipo)) return null;
  if (!isValidStatusForType(record.tipo, record.status)) return null;

  if (
    record.status === TRANSACTION_STATUS.RECEIVED ||
    record.status === TRANSACTION_STATUS.PAID
  ) {
    return TRANSACTION_STATE.REALIZED;
  }
  return TRANSACTION_STATE.PLANNED;
};

export const isRealizedTransaction = (record) => {
  const state = getTransactionState(record);
  if (state === null) return null;
  return state === TRANSACTION_STATE.REALIZED;
};

export const normalizeTransaction = (record) => {
  const source = record && typeof record === 'object' ? record : {};
  const amountCents = getAmountCents(source);
  const date = getFinancialDate(source);
  const type = isValidTransactionType(source.tipo) ? source.tipo : null;
  const status =
    type && isValidStatusForType(type, source.status) ? source.status : null;
  const state = type && status ? getTransactionState(source) : null;
  const errors = [];

  if (amountCents === null) errors.push('INVALID_AMOUNT');
  if (date === null) errors.push('INVALID_DATE');
  if (type === null) errors.push('INVALID_TYPE');
  if (status === null) errors.push('INVALID_STATUS');

  return {
    id: source.id ?? null,
    description: typeof source.nome === 'string' ? source.nome : '',
    amountCents,
    date,
    category: typeof source.categoria === 'string' ? source.categoria : '',
    type,
    status,
    state,
    realized: state === TRANSACTION_STATE.REALIZED
      ? true
      : state === TRANSACTION_STATE.PLANNED
        ? false
        : null,
    isValid: errors.length === 0,
    errors,
    original: source,
  };
};

export { TRANSACTION_TYPES };
